

import { Component } from '@angular/core';

@Component({
  selector: 'icon-pulse',
  standalone: true,
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
        <circle id="core" cx="12" cy="12.5" r="2" />
        <circle id="radar" cx="12" cy="12.5" r="2" />
    </svg>
  `,
  styles: `
    svg{
        cursor: pointer;
    }
    #core {
  fill: #fff;
  transform-origin: 12px 12.5px;
  animation: pulse1 1.5s ease-in-out infinite;
}

#radar {
  fill: rgba(255, 255, 255, 0.5); /* corregido el rgba */
  transform-origin: 12px 12.5px;
  animation: pulse2 1.5s ease-in-out infinite;
}

@keyframes pulse1 {
  0% {
    opacity: 0;
    transform: scale(0);
  }

  30% {
    opacity: 1;
    transform: scale(1.5);
  }

  60% {
    opacity: 1;
    transform: scale(2);
  }

  100% {
    opacity: 0;
    transform: scale(2);
  }
}

@keyframes pulse2 {
  0% {
    transform: scale(1, 1);
    opacity: 0;
  }

  50% {
    opacity: 1;
  }

  100% {
    transform: scale(6, 6);
    opacity: 0;
  }
}
    `
    })

export class PulseIconComponent {}
